import React, { forwardRef, ReactNode, AnchorHTMLAttributes } from "react";
import { Link, LinkProps } from "react-router-dom";
import styled from "styled-components";

export interface SntLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "onClick"> {
  children?: ReactNode;
  to?: string | LinkProps["to"];
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

// eslint-disable-next-line react/display-name
const _SntLink = forwardRef<HTMLAnchorElement | HTMLElement, SntLinkProps>(
  (props, ref) => {
    const { children, to, onClick, ...rest } = props;

    return to ? (
      <Link
        ref={ref as React.Ref<HTMLAnchorElement>}
        {...(rest as React.ComponentProps<typeof Link>)}
        to={to}
        onClick={(e) => {
          if (onClick) {
            e.preventDefault();
            e.stopPropagation();
            onClick(e);
          }
        }}
      >
        {children}
      </Link>
    ) : (
      <a
        ref={ref as React.Ref<HTMLAnchorElement>}
        {...rest}
        href="##"
        onClick={(e) => {
          if (onClick) {
            e.preventDefault();
            e.stopPropagation();
            onClick(e);
          }
        }}
      >
        {children}
      </a>
    );
  }
);

const SntLink = styled(_SntLink)`
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export default SntLink;
